<template>
  <v-app-bar clipped-left dense app>
    <v-spacer></v-spacer>


    <!-- Temporary disable FLAG drop-down -->
    <!--===- ->
    <v-menu bottom left>
      <v-btn
        slot="activator"
        icon
      >
        <flag :iso="currentFlag" :squared="false" />
      </v-btn>
      <v-list>
        <v-list-item
          v-for="lang in langs"
          :key="lang.locale"
          @click="changeLocale(lang)"
        >
          <v-list-item-content>
            <v-list-item-title><flag :iso="getFlag(lang.locale_lang)" :squared="false" :title="lang.name" /></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!- -===-->

    <v-progress-circular style="width: 175px;" v-if="isBusy" indeterminate></v-progress-circular>
    <img
      v-else
      src="../assets/logo.png"
      height="44"
      style="width: 175px;"
      :title="`(c) dimedis GmbH, Köln`"
    />
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Toolbar',
  components: {
  },
  data () {
    return {
      languages: [
        { locale_lang: 'de', locale: 'de_DE.UTF-8', title: 'Deutsch' },
        { locale_lang: 'en', locale: 'en_US.UTF-8', title: 'English' },
        // { flag: 'bg', locale: 'bg_BG', title: 'Български' },
        // { flag: 'ru', locale: 'ru_RU', title: 'Русский' },
      ],
      langMap: [
        { locale_lang: 'de', flag: 'de' },
        { locale_lang: 'en', flag: 'us' },
        { locale_lang: 'bg', flag: 'bg' },
        { locale_lang: 'ru', flag: 'ru' },
        { locale_lang: 'fr', flag: 'fr' },
        { locale_lang: 'sv', flag: 'se' },
      ],
    }
  },
  computed: {
    ...mapGetters(['isBusy']),
    langs() {
      return this.languages.filter(a => Object.keys(this.$i18n.messages).includes(a.locale))
    },
    currentFlag() {
      const lang = this.languages.find(a => a.locale === this.$i18n.locale)
      return lang ? this.getFlag(lang.locale_lang) : ''
    },
  },
  methods: {
    getFlag(locale_lang) {
      let lang = this.langMap.find(a => a.locale_lang === locale_lang)
      return lang ? lang.flag : ''
    },
    changeLocale(lang) {
      this.$i18n.locale = lang.locale;
    },
  },
}
</script>

<style>

</style>
